import { FormContainerProps } from '@occc-app/offerHelpers/types';
import { useGetConfigureFormProps } from '@occc-app/offerHelpers/hooks/useGetConfigureFormProps';

import { PromocodesConfigurationFrom } from './promocodes-configuration.form';
import { getConfigureFormOperations } from './promocodes-configuration.operations';
import { transformOfferToInitialValues } from './promocodes-configuration.utils';
import {
  PromocodesConfigureFormInitialValues,
  PromocodesConfigureFormValues,
} from './promocodes-configuration.types';

export const PromocodesConfigurationFormContainer = (props: FormContainerProps) => {
  const configureProps = useGetConfigureFormProps<
    PromocodesConfigureFormValues,
    PromocodesConfigureFormInitialValues
  >(props, transformOfferToInitialValues, getConfigureFormOperations);

  return <PromocodesConfigurationFrom {...configureProps} />;
};
